import { SET_GAME_DATA } from "../action-types";

import { gameDataReducer } from "./game-data/game-data-reducer";

export const gameContextReducer = (state: GameState, action) => {
    switch (action.type) {
        case SET_GAME_DATA:
            return gameDataReducer(state, action);
        default:
            return state;
    }
};
